module.exports = __webpack_public_path__ + "img/Fr-Ozoh-bg.c3c8334f.png";